var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUsaMiddle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1202",
    x: -7.572,
    y: 6.859,
    width: 71.514,
    height: 40.815,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4569",
    "data-name": "Group 4569",
    transform: "translate(170.28 10.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "united-states",
    transform: "translate(-170.28 -10.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(0.553 3.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M244.87,193.4h16.738a16.058,16.058,0,0,0-.553-4.185H244.87Z",
    transform: "translate(-230.161 -180.876)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M244.87,59.837h14.384a16.126,16.126,0,0,0-3.7-4.185H244.87Z",
    transform: "translate(-230.161 -55.652)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M106.588,459.835a15.865,15.865,0,0,0,9.944-3.487H96.644A15.865,15.865,0,0,0,106.588,459.835Z",
    transform: "translate(-91.141 -431.323)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M10.616,326.967h27.3a15.967,15.967,0,0,0,1.8-4.185H8.819A15.967,15.967,0,0,0,10.616,326.967Z",
    transform: "translate(-8.819 -306.1)",
    fill: "#d80000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M7.43,2.505H8.892l-1.36.988.519,1.6L6.692,4.1l-1.36.988L5.781,3.71A16.129,16.129,0,0,0,2.67,7.178h.468l-.866.629q-.2.337-.388.685L2.3,9.764,1.527,9.2Q1.24,9.813,1,10.449l.455,1.4H3.138l-1.36.988.519,1.6-1.36-.988-.814.592a16.2,16.2,0,0,0-.124,2H16.041V0A15.965,15.965,0,0,0,7.43,2.505Zm.621,11.932-1.36-.988-1.36.988.519-1.6-1.36-.988H6.173l.519-1.6.519,1.6H8.892l-1.36.988ZM7.533,8.166l.519,1.6-1.36-.988-1.36.988.519-1.6-1.36-.988H6.173l.519-1.6.519,1.6H8.892Zm6.273,6.271-1.36-.988-1.36.988.519-1.6-1.36-.988h1.681l.519-1.6.519,1.6h1.681l-1.36.988Zm-.519-6.271.519,1.6-1.36-.988-1.36.988.519-1.6-1.36-.988h1.681l.519-1.6.519,1.6h1.681Zm0-4.673.519,1.6L12.446,4.1l-1.36.988.519-1.6-1.36-.988h1.681l.519-1.6.519,1.6h1.681Z",
    fill: "#0052b4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsaMiddle);
export default __webpack_public_path__ + "static/media/icon_usa_middle.81b87a2fdcf789b752a630db219ba786.svg";
export { ForwardRef as ReactComponent };